import React from "react";
import _ReportCustomerSmryMultichannel from "../../components/reports/admin/customers/_ReportCustomerSmryMultichannel";
const ReportCustomerSmryMultichannel = () => {
  return (
    <div>
      <h2>Reporte Resumen Por Cliente</h2>
      <_ReportCustomerSmryMultichannel />
    </div>
  );
};

export default ReportCustomerSmryMultichannel;
